import React, { memo, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { gameKeys, paths } from 'src/constants';
import Container from 'src/components/pages/Activities/ReadAndThink/BonusLevels/Container';

const TIMEOUT_DURATION = 1000;

const ReadAndThinkBonusLevels = ({
  getBonusLevelsByCollectionId,
  hasLoaded,
  levels,
  currency,
  student,
  unlockCollection,
  updateFeedback,
}) => {
  const history = useHistory();
  const gameKey = gameKeys.READ_AND_THINK_BONUS;
  const { groupKey, collectionId } = useParams();

  useEffect(() => {
    getBonusLevelsByCollectionId(collectionId);
  }, [getBonusLevelsByCollectionId, collectionId]);

  const handleLevelAnswer = (levelId, isCorrect, currencyId) => {
    updateFeedback({ currencyId, gameKey, levelId, isCorrect });
  };

  const handleCollectionEnd = () => {
    unlockCollection({
      gameKey,
      collectionId,
    });
    setTimeout(() => {
      history.push(paths.build(paths.READ_AND_THINK, groupKey, collectionId));
    }, TIMEOUT_DURATION);
  };

  return (
    <Container
      currency={currency}
      handleCollectionEnd={handleCollectionEnd}
      handleLevelAnswer={handleLevelAnswer}
      hasLoaded={hasLoaded}
      items={levels}
      student={student}
    />
  );
};

ReadAndThinkBonusLevels.propTypes = {
  getBonusLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  levels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currency: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  student: PropTypes.shape({}).isRequired,
  unlockCollection: PropTypes.func.isRequired,
  updateFeedback: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.readAndThinkBonusLevels.getHasLoaded(state),
  currency: selectors.readAndThinkBonusLevels.getCurrencyData(state),
  levels: selectors.readAndThinkBonusLevels.getLevelsData(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.readAndThink,
  ...actions.feedback,
  ...actions.students,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ReadAndThinkBonusLevels);
